<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <card-header :title="title" :icon="icon"></card-header>
          <v-card-text>
            <ValidationObserver v-slot="{ handleSubmit, invalid }">
              <form @submit.prevent="handleSubmit(requestPayments)">
                <v-row>
                  <!-- 기부자명 -->
                  <v-col :cols="fields.payerName.size">
                    <ValidationProvider :name="$t(fields.payerName.label)" :rules="fields.payerName.rules"
                      v-slot="{ errors }">
                      <v-text-field v-model="paymentInfo.payer" :label="$t(fields.payerName.label)"
                        :error-messages="errors" prepend-icon="mdi-account" outlined dense></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <!-- 기부자 이메일 -->
                  <v-col :cols="fields.payerEmail.size">
                    <ValidationProvider :name="$t(fields.payerEmail.label)" :rules="fields.payerEmail.rules"
                      v-slot="{ errors }">
                      <v-text-field v-model="paymentInfo.email" :label="$t(fields.payerEmail.label)"
                        :error-messages="errors" prepend-icon="mdi-email" outlined dense></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- 메모 -->
                  <v-col :cols="fields.memo.size">
                    <v-text-field v-model="paymentInfo.memo" :label="$t(fields.memo.label)" prepend-icon="mdi-note"
                      outlined dense></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- 금액 -->
                  <v-col :cols="fields.amount.size">
                    <ValidationProvider :name="$t(fields.amount.label)" :rules="fields.amount.rules"
                      v-slot="{ errors }">
                      <v-text-field v-model.number="paymentInfo.amount" :label="$t(fields.amount.label)"
                        :error-messages="errors" prepend-icon="mdi-cash" type="number" outlined dense></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <!-- 통화 -->
                  <v-col :cols="fields.currency_code.size">
                    <ValidationProvider :name="$t(fields.currency_code.label)" :rules="fields.currency_code.rules"
                      v-slot="{ errors }">
                      <v-select v-model="paymentInfo.currency_code" :items="fields.currency_code.options"
                        :label="$t(fields.currency_code.label)" prepend-icon="mdi-currency-usd" outlined dense
                        :error-messages="errors"></v-select>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-card-actions>
                  <custom-button :disabled="invalid" type="submit" :label="$t('button.payment')" color="primary"
                    size="lg" class="ml-auto" gradient rounded></custom-button>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardHeader from '@/components/cards/CardHeader.vue';
import { donationFormInfo } from '@/views/PaymentView/fields';
import { extend } from 'vee-validate';
import CustomButton from '@/components/common/buttons/CustomButton.vue';
import { required, numeric, email } from 'vee-validate/dist/rules';

extend('required', { ...required });
extend('numeric', { ...numeric });
extend('email', { ...email });

export default {
  components: {
    CustomButton,
    CardHeader,
  },
  data() {
    return {
      title: this.$t('title.donation'),
      icon: 'mdi-heart',
      fields: donationFormInfo,
      paymentInfo: {
        payer: null,
        email: null,
        amount: 0,
        currency_code: null,
        memo: null,
      },
    };
  },
  methods: {
    requestPayments() {
      this.$emit('request-payments', this.paymentInfo);
    },
  },
};
</script>

<style scoped></style>
